module.exports = __webpack_public_path__ + "img/1723595444784-image.jpg.c07bc894.webp";